import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Row, Input, Label, select,AccordionItem,AccordionBody,AccordionHeader,UncontrolledAccordion, FormGroup} from "reactstrap";
import moment from "moment";
import "../Account/jobspace-account.css"; // new JobSpace design system (reskin only)
//import { Button, Accordion, } from "react-bootstrap";

//Import Images
import { AppConfiguration } from "read-appsettings-json";
import { GetRequest, PostRequest } from '../../noser-dataaccess'
import axios from 'axios'
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import '../../noser-hris.css';
import AWS from 'aws-sdk';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import FileViewer from 'react-file-viewer-extended'; 

const ListOfCandidate = () => {

    const getFormattedDateTime = () => {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');
    
        return `${year}${month}${day}${hours}${minutes}${seconds}`;
    };
    const sleep = (milliseconds) => {return new Promise(resolve => setTimeout(resolve, milliseconds))}
    const [validateTmp, setValidateTmp] = useState(JSON.parse(sessionStorage.getItem("validate")));
    const [fltrTmp, setFilter] = useState(JSON.parse(sessionStorage.getItem("JobPostingList")));
    const [listOfJobs, setDlistOfJobs] = useState([]);
    const [mainGrid, setmainGrid] = useState([]);
    const [companyProfiles, setcompanyProfiles] = useState([]);
    const [jobPosted, setjobPosted] = useState([]);
    const [search, setsearch] = useState("");
    const [statusData, setstatusData] = useState([
       
        {
           "id":"1",
           "label":"New",
           "value":"NW"
        },
        {
            "id":"2",
            "label":"pre-screen",
            "value":"PS"
        },
        {
            "id":"3",
            "label":"keep warm",
            "value":"KW"
        },
        {
            "id":"4",
            "label":"shorlisted",
            "value":"SL"
        },
        {
            "id":"5",
            "label":"not qualified",
            "value":"NQ"
        },
    ]);
    const [jobRef, setjobRef] = useState("");
    const [pstingDateFilter, setpstingDateFilter] = useState("");
    const [jobPostStatus, setjobPostStatus] = useState("");
    const [jobtitlefilter, setjobtitlefilter] = useState("");
    const [endDateFilter, setendDateFilter] = useState("");
    const [validateSession, setValidate] = useState("0");
    const [candidProfLst, setCandidProf] = useState([]);
    //const [s3dataall, sets3dataall] = useState([]);
    const [urls3docs, seturls3docs] = useState([]);
    const [showViewer, setShowViewer] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [contentType, setcontentType] = useState("");


    const rowClasses = 'custom-row-class-success';


    useEffect(() => {
        GetCandidatesProfile()
        //fetchS3Objectstest();
    },[]);
    let s3dataall = []
    const fetchS3Objectstest = async () => {
        // Configure AWS SDK
        const S3_BUCKET = 'job-space-bucket-noser-cdr';
        const REGION = 'us-east-1';
        const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
        const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
    
        AWS.config.update({
            accessKeyId: ACCESS_KEY,
            secretAccessKey: SECRET_KEY,
            region: REGION,
        });
        const s3 = new AWS.S3();
        const params = {
            Bucket: 'job-space-bucket-noser-cdr',
        };
        
        s3.listObjectsV2(params, (err, data) => {
            if (err) {
                console.log("Error fetching objects from S3: ", err);
            } else {
                console.log("Fetched objects: ", data.Contents);
                s3dataall = data.Contents
                
            }
        });
        await sleep(5000)
        console.log("s3dataall")
        console.log(s3dataall)
        //sets3dataall(newdat);
        
    }

    async function GetCandidatesProfile (){

        let dataTmp = []
        let filter_data = {"isDeleted": "0"}
        const params = {

            "dbname"      :  AppConfiguration.Setting().noserJobSpaceDB_Prod,
            "_collection" : "CandidatesProfile",
            "filter_data" : filter_data

        };

        // console.log("params")
        // console.log(params)

        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", params)
        .then(res => {

            let data = res.data
            // console.log("data")
            // console.log(data)

            data.CandidatesProfile.map(function(itm,i){

                const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
                const json = JSON.parse(strJson.replace(/'/g,'"'));
                // console.log("json")
                // console.log(json)
                dataTmp.push(json)

            })       
            
            // setJson(dataTmp)  
            // // console.log("dataTmp")
            // // console.log(dataTmp)
            setCandidProf(dataTmp); 
            GetCandidates(dataTmp)

        })
        
    }
    const helperBuildCriteria=()=>{

        ///// FOR TRANSAC DATE FILTER SOON
       /*  let checkDateStart = moment(this.state.startDate).format('MM/DD/YYYY');
        let checkDateEnd = moment(this.state.endDate).format('MM/DD/YYYY');
        const checkAll = this.state.deductionSummaryGrid

        let objCheckList = []
        for (let i = 0; i < checkAll.length; i++) {
            //////////////// // // console.log(checkAll[i])
            if (checkAll[i]["transactionDate"] >= checkDateStart &&  checkAll[i]["transactionDate"] <= checkDateEnd ){
                objCheckList.push(checkAll[i])
                ////////////// // // console.log(objCheckList)
            }else{

            }
        } */

        //let newtransacDate = new Date(this.state.transacDate)
        let _transacDate = ""//moment(newtransacDate).format('MM/DD/YYYY');
        

        let _filterData = ""
       
        let _jobRefNo = ""
        let _jobtitle = ""
        let _postingDate = ""
        let _EndDate = ""
        let _status = "" 

        //let transactionDate = (this.state.transactionDate) ? moment(this.state.transactionDate).format('MM/DD/YYYY') : ""
        
        if (jobRef != "" || jobRef !== "") {
            _jobRefNo = "postingId" + ":" + jobRef + ","
        }
        if (pstingDateFilter != "" || pstingDateFilter !== "") {
            _postingDate = "postingId" + ":" + pstingDateFilter + ","
        }
        if (endDateFilter != "" || endDateFilter !== "") {
            _EndDate = "endDate" + ":" + endDateFilter + ","
        }
        if (jobtitlefilter != "" || jobtitlefilter !== "") {
            _jobtitle = "title" + ":" + jobtitlefilter + ","
        }
      
        _filterData = _jobRefNo + _status + _jobtitle + _postingDate + _EndDate
        
        return _filterData
    }

    const handleChangeSearch = () => {
        let _fdata = helperBuildCriteria()
        let _filterData = _fdata.split(",")
        let _objfd = {}

        let jsonData = {};
        for (let i = 0; i < _filterData.length - 1; i++) { 
            let columnName = _filterData[i].split(":")[0]
            _objfd[columnName] = _filterData[i].split(":")[1];
        }
        // // // console.log("filter_data")
        // // // console.log(_objfd)

        GetFilterResult(_objfd);
    }

    const GetFilterResult = async(_objfd) => {

        let filter_data = {}
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : _objfd
        }
        // // // console.log("Params GetFilterResult")
        // // // console.log(Params)
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            // // // console.log("data")
            // // // console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //// // // console.log("itm")
                //// // // console.log(itm)
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    

            setDlistOfJobs(dataTmp)  
            let dataArry = dataTmp.filter((thing, index, self) =>
                index === self.findIndex((t) => (
                t.postingId === thing.postingId
            )))  
            setmainGrid(dataArry) 
        })
        .catch(error =>{
            alert("error: " + error)
        })
        GetCompanyProfile()
    }

    const GetCandidatesFilterd = async(toEdit) => {

        let filter_data = {postingId:toEdit.postingId }
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            //// // // console.log("data")
            //// // // console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //// // // console.log("itm")
                //// // // console.log(itm)
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    
            //// // // console.log(dataTmp)

            setDlistOfJobs(dataTmp)   
            setmainGrid(dataTmp) 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    }

    const GetCandidates = async(ItemLst) => {

        let filter_data = {"isDeleted": "0", }
        let dataTmp = []

        const Params = {
          "_collection" : "Candidates",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            // // // console.log("data GetCandidates")
            // // // console.log(data)
            let newstr2=""
            data.Candidates.map(function(itm,i){
                //// // // console.log("itm")
                //// // // console.log(itm)
                const strJson = itm.replace("","").replace("ObjectId(","").replace(")","").replace("_","")
                const json = JSON.parse(strJson.replace(/'/g,'"'));
                dataTmp.push(json)
            })    

            dataTmp.map(function(item,i){
                let checkResume = ItemLst.filter(f => f.UserId === item.email)
                console.log("checkResume")
                console.log(checkResume)
                if(checkResume.length > 0){
                    item.isResume = checkResume[0].newIdResume !== "" ? "1" : "0"
                }
                
            })
            let fltrFullAcss = dataTmp /* .filter(f => ItemLst.some(item => item.UserId === f.employeeId)) */
             console.log("dataTmp GetCandidates")
             console.log(dataTmp)
            // // console.log("dataTmp")
            // // console.log(dataTmp)
            // // console.log("fltrFullAcss.filter(x => x.postingId === fltrTmp.postingId && x.title === fltrTmp.title)")
            // // console.log(fltrFullAcss.filter(x => x.postingId === fltrTmp.postingId && x.title === fltrTmp.title))
            if(String(validateTmp)==="1") {
                setmainGrid(fltrFullAcss.filter(x => x.postingId === fltrTmp.postingId && x.title === fltrTmp.title))
                setjobRef(fltrTmp.postingId)
                setjobtitlefilter(fltrTmp.title)
            }
            else {
                setDlistOfJobs(fltrFullAcss)   
                setmainGrid(fltrFullAcss) 
            }
        })
        .catch(error =>{
            alert("error in GetCandidates function: " + error)
        })
    }

    const fetchS3Objects = () => {
        return new Promise((resolve, reject) => {
            const S3_BUCKET = 'job-space-bucket-noser-cdr';
            const REGION = 'us-east-1';
            const ACCESS_KEY = AppConfiguration.Setting().accessKeyId;
            const SECRET_KEY = AppConfiguration.Setting().secretAccessKey;
        
            AWS.config.update({
                accessKeyId: ACCESS_KEY,
                secretAccessKey: SECRET_KEY,
                region: REGION,
            });
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
            };

            s3.listObjectsV2(params, (err, data) => {
                if (err) {
                    // console.log("Error fetching objects from S3: ", err);
                    reject(err);
                } else {
                    // console.log("Fetched objects: ", data.Contents);
                    resolve(data.Contents);
                }
            });
        });
    };

    const getObjectUrl = (key) => {
        return new Promise((resolve, reject) => {
            const s3 = new AWS.S3();
            const params = {
                Bucket: 'job-space-bucket-noser-cdr',
                Key: key,
                // Expires: 60
            };
    
            s3.getSignedUrl('getObject', params, (err, url) => {
                if (err) {
                    console.error("Error generating signed URL: ", err);
                    reject(err);
                } else {
                    resolve(url);
                }
            });
        });
    };

    const viewS3Object = (objectKey) => {
        const s3 = new AWS.S3();
        const params = {
            // Bucket: 'noser-space-bucket-js-v1.sgp1.cdn.digitaloceanspaces.com',
            Bucket: 'job-space-bucket-noser-cdr',
            Key: objectKey,
        };

        const fileType = objectKey.split('.').pop().toLowerCase();
        // console.log("fileType: ", fileType);

        if (fileType === 'docx' || fileType === 'pdf') {
            s3.getSignedUrl('getObject', params, (err, url) => {

                if (err) {
                    console.error("Error generating pre-signed URL: ", err);
                } else {
                    this.setState({ selectedFileContent: <img src={url} style={{ width: '100%', height: '500px', border: 'none' }} alt="Image Document" /> });
                }
            })
        } else {
            s3.getObject(params, (err, data) => {
                if (err) {
                    console.error("Error getting object from S3: ", err);
                } else {
                    // console.log("Object fetched successfully: ", data);
        
                    const pdfBlob = new Blob([data.Body], { type: 'application/pdf' });
                    const pdfUrl = URL.createObjectURL(pdfBlob);
        
                    this.setState({ selectedFileContent: <iframe src={pdfUrl} style={{ width: '100%', height: '500px', border: 'none' }} title="PDF Document"></iframe> });
                }
            });
        }

    }

    const GetCompanyProfile = async() => {
        let filter_data = {"isDeleted": "0", }
        let dataTmp = []
        const Params = {
          "_collection" : "CompanyProfile",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            let newstr2=""
            data.CompanyProfile.map(function(itm,i){
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    

            //// // // console.log("dataTmp GetCompanyProfile")
            //// // // console.log(dataTmp)
            setcompanyProfiles(dataTmp)   
          
            
            // setJson(dataTmp)  
            //GetJobPosted(dataTmp); 
        })
        .catch(error =>{
            alert("error: " + error)
        })
    };

    const GetJobPosted = async(dataTmp) => {
        //// // // console.log("dataTmp GetJobPosted")
        //// // // console.log(dataTmp)
        let filter_data = {"isDeleted": "0", "companyId" : dataTmp[0].companyId}
        let JobPostedTmp = []
        const Params = {
          "_collection" : "JobPosting",
          "filter_data" : filter_data
        }
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            let newstr2=""
            data.JobPosting.map(function(itm,i){
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                JobPostedTmp.push(json)
            })       
            //// // // console.log("JobPostedTmp GetJobPosted")
            //// // // console.log(JobPostedTmp)

            setjobPosted(JobPostedTmp)
            
            // setJson(dataTmp)  
        })
        .catch(error =>{
            alert("error: " + error)
        })
    };

 
  
    /* Get items */
    async function OnLoadScreen(){
        // setJobType("")
        // setCategory("")
        // setJobOverviewLocation("")
        // setOfferedSalary("")
        // setPosted("")
        // setExperience("")
        // setGender("0")
        // setIndustry("")
        // setQualification("")
        // setLevel("")
        // setApplied("")
    }

    const rowEvents = {
      /*   onClick: (e, row, rowIndex) => {
            //// // // console.log("onClick")
            //// // // console.log(rowIndex)
            //handleView(row)
           
        }, */
     
    };

    const handleViewResume=async(row)=>{
        console.log("handleViewResume")
        console.log(row)
        //sessionStorage.setItem("viewProfile", JSON.stringify(row.employeeId))
       // window.location.href='/AppFormView'
        // handleDownloadResume(row)
        
        // handleDownloadResume(row);

        //getcandidateprofile(row )
        //return;
        let checkCP = "0"
        let filter_data = {"UserId" : row.email}
        let getNewId = ""
        const Params = {
          "_collection" : "CandidatesProfile",
          "filter_data" : filter_data
        }

        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/get", Params)
        .then(res => {

            let data = res.data
            // console.log("data")
            // console.log(data)
            let newstr2=""
            let dataTmp = []
            data.CandidatesProfile.map(function(itm,i){
                //// console.log("itm")
                //// console.log(itm)
                let strJson = "{" + itm.substring(46, itm.length)
                let strJson2 = itm.substring(18, itm.length)
                newstr2 = strJson2.split("')")[0]
                let json = JSON.parse(strJson.replace(/'/g,'"'));
                json.headerId = newstr2
                dataTmp.push(json)
            })    
            console.log("dataTmp GetCandidates" )
            console.log(dataTmp)
            checkCP="1"
            getNewId = dataTmp[0].newIdResume
            if (!dataTmp[0].newIdResume) {
                console.error("Invalid row object or missing newId property:",);
                alert("Unable to download resume. Please ensure the candidate data is valid.");
                return;
            }
           
        })
        .catch(error =>{
            checkCP="0"
            alert("error: " + "Cannot found Candidate Profile")
        })

        await sleep(1500)

        if(checkCP ==="0"){
            console.log("checkCP 0")
            alert("Unable to /view resume. Please ensure the candidate data is valid.");
            // const s3Objects = await fetchS3Objects();
            // const keys = s3Objects.map((object) => object.Key);
            // for (let i = 0; i < keys.length; i++) {
            //     const key = keys[i];
            //     const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
            //     const last14Digits = keyWithoutExtension.slice(-14);
            //     /* console.log("last14Digits")
            //     console.log(last14Digits) */
            //     if (last14Digits === "20260625172846") {
            //         console.log(`Match found: ${last14Digits} in key: ${key}`);
            //         const s3 = new AWS.S3();
            //         const params = {
            //             Bucket: 'job-space-bucket-noser-cdr',
            //             Key: key,
            //         };
            
            //         const fileType = key.split('.').pop().toLowerCase();
            //         console.log("fileType: ", fileType);
            
                
            //         s3.getObject(params, (err, data) => {

            //             if (err) {
            //                 console.error("Error getting object from S3: ", err);
            //             } else {
            //                 console.log("Object fetched successfully: ", data);
            //                 console.log("last14Digits")
            //                 console.log("application/"+ fileType)
            //                 setcontentType(fileType);

            //                 const pdfBlob = new Blob([data.Body], { type: /* "application/"+ fileType */ "application/jpeg" });
            //                 const pdfUrl = URL.createObjectURL(pdfBlob);

            //                 console.log("pdfUrl: ", pdfUrl);  
            //                 seturls3docs(pdfUrl);
            //                 setShowViewer(true);
            //             }

            //         });
            //     }
            // }

        }else{
    console.log("check 1")
            const s3Objects = await fetchS3Objects();
            const keys = s3Objects.map((object) => object.Key);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                const last14Digits = keyWithoutExtension.slice(-17);
                
                if (last14Digits === getNewId) {
                    console.log("20260629210903743")
                    console.log(getNewId)
                    console.log("last14Digits")
                    console.log(last14Digits)

                    
                    console.log(`Match found: ${last14Digits} in key: ${key}`);
                    const s3 = new AWS.S3();
                    const params = {
                        Bucket: 'job-space-bucket-noser-cdr',
                        Key: key,
                    };
            
                    const fileType = key.split('.').pop().toLowerCase();
                    console.log("fileType: ", fileType);
                    setcontentType(fileType);
            
                
                    s3.getObject(params, (err, data) => {

                        if (err) {
                            console.error("Error getting object from S3: ", err);
                        } else {
                            console.log("Object fetched successfully: ", data);
                
                            const pdfBlob = new Blob([data.Body], { type: `application/${fileType}` });
                            const pdfUrl = URL.createObjectURL(pdfBlob);
                            console.log("pdfUrl: ", pdfUrl);  
                            seturls3docs(pdfUrl);
                            setShowViewer(true);
                        }

                    });
                }
            }
        }

        

      
    }


    const handleDownloadResume = async (row) => {

        console.log("row");
        console.log(row);

        let keyforResume = "";
        try {
            const filter_data = { UserId: row.email };
            const Params = {
                _collection: "CandidatesProfile",
                filter_data: filter_data,
            };

            const res = await axios.post(AppConfiguration.Setting().jobspaceapi + "action/get", Params);
            const data = res.data;
            let dataTmp = [];
            data.CandidatesProfile.map(function (itm, i) {
                let strJson = "{" + itm.substring(46, itm.length);
                let strJson2 = itm.substring(18, itm.length);
                let newstr2 = strJson2.split("')")[0];
                let json = JSON.parse(strJson.replace(/'/g, '"'));
                json.headerId = newstr2;
                dataTmp.push(json);
            });

            if (dataTmp.length > 0) {
                keyforResume = dataTmp[0].newIdResume;
            }
        } catch (error) {
            alert("error: " + error);
            return;
        }

        if (!keyforResume) {
            console.error("Invalid row object or missing newId property:", row);
            alert("Unable to download resume. Please ensure the candidate data is valid.");
            return;
        }
    
        // console.log("handleDownloadResume");
        // console.log("Candidate taggingId:", row.newId);
        const bucketName = 'job-space-bucket-noser-cdr'; 
        const region = 'us-east-1';

        let checkLink="0"
        let getLink=""
    
        try {
            const s3Objects = await fetchS3Objects();
            const keys = s3Objects.map((object) => object.Key);
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                const keyWithoutExtension = key.split('.').slice(0, -1).join('.');
                const last14Digits = keyWithoutExtension.slice(-17);

                if (last14Digits === keyforResume) {
                    console.log(`Match found: ${last14Digits} in key: ${key}`);
                    const docURL = await getObjectUrl(key);
                    console.log("Expected URL:", docURL);

                    const link = document.createElement('a');
                    link.style.display = 'none';
                    link.href = docURL;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    // set a filename to hint the browser to download
                    link.download = key.split('/').pop() || 'resume';
                    document.body.appendChild(link);
                    try {
                        link.click();
                    } catch (err) {
                        // fallback to window.open if click is blocked
                        window.open(docURL, '_blank');
                    }
                    document.body.removeChild(link);
                    return;
                }

               /*  if (last14Digits === keyforResume) {
                    console.log("key: ", key);
                    console.log("keyWithoutExtension: ", keyWithoutExtension);
                    console.log("last14Digits: ", last14Digits);
                    console.log("Candidate taggingId:", keyforResume);

                    console.log(`Match found: ${last14Digits} in key: ${key}`);
                    const docURL = await getObjectUrl(key);
                    console.log("Expected URL:", docURL);
                    const link = document.createElement('a');
                    link.href = docURL;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    break;
                } */
                /* else {
                    if (i === keys.length - 1) {
                        alert("Document not found!");
                    }
                } */
                // for (const key of keys) {
                //     const keyWithoutExtension = key.split('.').slice(0, -1).join('.'); 
                //     const last14Digits = keyWithoutExtension.slice(-14);
                //     console.log("key: ", key);
                //     console.log("keyWithoutExtension: ", keyWithoutExtension);
                //     console.log("last14Digits: ", last14Digits);
                //     console.log("Candidate taggingId:", keyforResume);
        
                //     if (last14Digits === keyforResume) {
                //         // console.log(`Match found: ${last14Digits} in key: ${key}`);
        
                //         // const docURL = `https://${bucketName}.s3.${region}.amazonaws.com/${key}`;
                //         const docURL = await getObjectUrl(key);
                //         // console.log("Expected URL:", docURL);
        
                //         const link = document.createElement('a');
                //         link.href = docURL; 
                //         document.body.appendChild(link);
                //         link.click();
                //         document.body.removeChild(link);
        
                //         break;
                //     }
                //     else {
                //         alert("Document not found!");
                //         break;
                //     }
                // }
            }

           // await sleep(5000)
            /* if(checkLink ==="1"){
                console.log("checkLink ===:", checkLink);
                const link = document.createElement('a');
                link.href = getLink; 
                console.log("link:", link);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } */
    
        } catch (error) {
            console.error("Error fetching S3 objects:", error);
            alert("Error fetching document from storage.");
        }
    };


    const handleSchedInterview=(row)=>{
        //// // // console.log("handleSchedInterview")
        //// // // console.log(row)
        //sessionStorage.setItem("jobPostedEdit", JSON.stringify(row))
       // window.location.href='/CreateJobPosting'
      
    }

    const handleView=(row)=>{
        //// // // console.log("handleView")
        //// // // console.log(row)
        //sessionStorage.setItem("jobPostedEdit", JSON.stringify(row))
       // window.location.href='/CreateJobPosting'
      
    }

    const onChangeSearch=(e)=>{
        //// // // console.log("handleSearch")
        //// // // console.log(e.target.value)
        setsearch(e.target.value)
        //// // // console.log(listOfJobs)
        if(e.target.value === ""){
            //// // // console.log("search === blank")
            setmainGrid(listOfJobs)
        }
        //sessionStorage.setItem("jobPostedEdit", JSON.stringify(row))
       // window.location.href='/CreateJobPosting'
      
    }
    
    const onClickSearch =()=>{
        let newarry = []
        listOfJobs.map(function(d){
         
            if(d.postingId == search){
                //// // // console.log("onClickSearch")
                //// // // console.log(d)
                setmainGrid([d])
            }
            if(d.title == search){
                //// // // console.log("onClickSearch")
                //// // // console.log(d)
                setmainGrid([d])
            } 
            if(d.name == search){
                //// // // console.log("onClickSearch")
                //// // // console.log(d)
                setmainGrid([d])
            } 
            if(d.expectedSalary == search){
                //// // // console.log("onClickSearch")
                //// // // console.log(d)
                setmainGrid([d])
            } 
            if(d.city == search){
                //// // // console.log("onClickSearch")
                //// // // console.log(d)
                setmainGrid([d])
            }
          
        })
    }

    const GridDataModified=(oldValue, newValue, id, column , index)=>{
        
        mainGrid.map(function(item,i,index) {
            
            if (item.id === id){
                item.isModified = newValue!=oldValue ? "1" : "0"
                
               /*  // // // console.log("GridDataModified item")
                // // // console.log(item.isModified)
                // // // console.log(item.headerId) */
                if(item.isModified == "1"){

                    item.status = newValue
                    item.isModified = "0"
                    saveGrid(item)
                 
                }
               
                
                
            }
        })
    }

    const saveGrid=(item)=>{
        let d = new Date(item.dateApplied);
        let createddate = moment(d).format('MM/DD/YYYY');
        let compCode = JSON.parse(sessionStorage.getItem("userCollection"))

        console.log(item)

        let dataTmp = {

            IsProcess : item.IsProcess,
            city : item.city,
            companyCode : compCode[0].companycode,
            companyName : item.companyName,
            contact : item.contact,
            createdBy : item.createdBy,
            createdDate : item.createdDate,
            dataPrivacy : item.dataPrivacy,
            dateApplied : createddate, //modified by waL-Tzy
            educLevel : item.educLevel,
            email : item.email,
            employeeId : item.employeeId,
            employementType : item.employementType,
            endDate : item.endDate,
            expectedSalary : item.expectedSalary,
            experience : item.experience,
            headerId : item.headerId,
            industry : item.industry,
            isDeleted : item.isDeleted,
            isModified : "0",
            isPhr : item.isPhr,
            isRegister : item.isRegister,
            isResume : item.isResume,
            jobDepartment : item.jobDepartment,
            jobDocNo : item.jobDocNo,
            level : item.level,
            message : item.message,
            modifiedDate : item.modifiedDate,
            modifiedby : item.modifiedby,
            name : item.name,
            newId : item.newId,
            postingId : item.postingId,
            qualification : item.qualification,
            resume : item.resume,
            status : item.status,
            title : item.title,
            procStatus : item.procStatus,
            dateHired : item.dateHired,
            remarks : item.remarks,
            dateStart : item.dateStart,


        }
        const updateParams = {
    
            "_collection" : "Candidates",
            "doc_data"    : dataTmp,
            "_id"         : item.id,
      
        }

    
        console.log("updateParams")
        console.log(updateParams)
      
        axios
        .post(AppConfiguration.Setting().jobspaceapi + "action/update_one", updateParams)
        .then(res => {
            let data = res.data
            
            // // // console.log("update_one data")
            // // // console.log(data)
            // // // console.log("update_one data end")
          
        
        }).catch(error =>{
            
            // // // console.log("error: " + error)
          
    
        })
    }

    const onChangejobRef = (e) => {
        setjobRef(e.target.value)
    }
    const onChangepstingDateFilter = (e) => {
        setpstingDateFilter(e.target.value)
    }
    const onChangejobPostStatus = (e) => {
        setjobPostStatus(e.target.value)
    }
    const onChangejobtitlefilter = (e) => {
        setjobtitlefilter(e.target.value)
    }
    const onChangeendDateFilter = (e) => {
        setendDateFilter(e.target.value)
    }

    /* Romel  */
    const handleClickClear = () =>{
        sessionStorage.removeItem("validate")
        sessionStorage.removeItem("JobPostingList")
        // GetCandidates()
        window.location.reload(true)
    }

    const columns = [
        {
            dataField   : 'postingId',
            text        : 'Job Post Reference',
            editable:false,
            headerStyle : () => {
            
                return { width  : "20%", color:"green", fontWeight : "bold" };
            },
            style:{/* textAlign: 'right', */ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
        },
        {
            dataField   : 'title',
            text        : 'Job Title',
            editable:false,
            headerStyle : () => {
                return { width  : "30%", color:"green", fontWeight : "bold" };
            },
            style:{/* textAlign: 'right', */ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000"}
        },
        {
            dataField   : 'name',
            text        : 'Name of Candidate',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{/* textAlign: 'right', */ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
        },
        {
            dataField   : 'expectedSalary',
            text        : 'Expected Salary',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{/* textAlign: 'right', */ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
        },
        {
            dataField   : 'city',
            text        : 'City',
            editable:false,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{/* textAlign: 'right', */ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000" }
        },
        {

            dataField   : 'isResume',
            text        : 'Resume',
            editable:false,
            classes: 'demo-key-row',
            headerStyle : () => {
                return { width  : "14%", color:"green", fontWeight : "bold" };
            },
            style:{whiteSpace: 'nowrap',color:"green",fontStyle:"bold" },
            formatter   :   (cell, row, isSelect) => {
                if(row.isResume === "0"){
                    return (
                        <div>
                            {/* <button color="link" style={{border:"none",background:"#ffffff",color:"green",marginLeft:"10px",}} variant="link" 
                                // onClick={e => handleViewResume(row)}
                                onClick={e => {
                                    // console.log("Row data for View:", row);
                                    handleViewResume(row);
                                }}>
                                {<i>View</i>}
                            </button>&nbsp;
                            <button color="link" style={{marginLeft:"10px",border:"none",background:"#ffffff",color:"green"}}  variant="link" onClick={e => handleDownloadResume(row)}>
                                { <i>Download</i>}
                            </button> */}
                        </div>
                    );
                }
                else{
                    return (
                       <div>
                            <button color="link" style={{border:"none",background:"#ffffff",color:"green",marginLeft:"10px",}} variant="link" 
                                // onClick={e => handleViewResume(row)}
                                onClick={e => {
                                    // console.log("Row data for View:", row);
                                    handleViewResume(row);
                                }}>
                                {<i>View</i>}
                            </button>&nbsp;
                            <button color="link" style={{marginLeft:"10px",border:"none",background:"#ffffff",color:"green"}}  variant="link" onClick={e => handleDownloadResume(row)}>
                                { <i>Download</i>}
                            </button>
                        </div>
                    );
                }
            },
        },
        {
            dataField   : 'status',
            text        : 'Status',
            editable:(content, row, rowIndex, columnIndex) => row.status === "Hired" ? false:true ,//true,
            headerStyle : () => {
                return { width  : "10%", color:"green", fontWeight : "bold" };
            },
            style:{/* textAlign: 'right', */ whiteSpace: 'nowrap',fontSize:'14px', color: "#000000"},
            editor: {
                type: Type.SELECT,
                options: statusData
            },
        },
        
       
    ]

    const selectRow = {
        mode: 'checkbox',
        clickToSelectAndEditCell: false,
        hideSelectColumn: true,
        onSelect: (row, isSelect, rowIndex, e) => {
            let disable = true
            listOfJobs.map(function(item,i){
                if(item.id===row.id)
                {
                    // // // console.log(row)
                    item.isDeleted = isSelect ? "1" : "0"
                    item.isModified = isSelect ? "1" : "0"
                    disable = isSelect ? false : true
                }
            })
        }
    };

    return (
        <React.Fragment>
            <div className="jsa-root" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", background: "#f4f7f4", minHeight: "100vh", color: "#16271f", padding: "8px 0 60px" }}>
            <Card className="job-detail overflow-hidden mt-1" style={{ background: "transparent", border: "none", boxShadow: "none" }}>
                {showViewer===false ?<CardBody className="p-4" style={{ marginTop : "3%"}}>
                    <Row>
                        <Col lg={1}></Col>
                        <Col lg={10}>
                            <Label className="mt-3" style={{color:"#16271f", fontSize: "26px", fontWeight: 800, letterSpacing: "-.02em", marginTop:"25px"}}>Applied Candidates</Label><br />
                            <Card className="mt-3" style={{ border: "1.5px solid #e8ede9", borderRadius: 18, boxShadow: "0 8px 26px rgba(20,50,38,.05)" }}>
                                <Row className="mt-2">
                                    <Col lg={1}>
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px', color:"#0A6219", fontSize: "14px", fontWeight: "bold"}}>Job Post Reference : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-55px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={jobRef}
                                            onChange={onChangejobRef}
                                                
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>Posted Date : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="date"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={pstingDateFilter}
                                            onChange={onChangepstingDateFilter}
                                                
                                        />
                                    </Col>
                                    
                                </Row>
                                <Row className="mt-3"  style={{  marginBottom:"20px",}}>
                                    <Col lg={1}>
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px', color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>Job Title : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-55px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={jobtitlefilter}
                                            onChange={onChangejobtitlefilter}
                                                
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        <Label  style={{ marginTop:"10px", marginLeft:'29px',color:"#0A6219" , fontSize: "14px", fontWeight: "bold"}}>End Date : </Label>
                                    </Col>
                                    <Col lg={2}>
                                        <Input
                                            type="date"
                                            className="form-control"
                                            id="nameControlInput"
                                            //placeholder="Max Salary Offer"
                                            style={{ borderStyle: "outset",marginLeft:"-85px"/* marginBottom:"5px",background:"#F0FEED" */}}
                                            value={endDateFilter}
                                            onChange={onChangeendDateFilter}
                                        />
                                    </Col>
                                    <Col lg={2}>
                                        <button type="submit" className="jsa-primary" onClick={handleChangeSearch} style={{ padding: "9px 22px", textAlign: "center", marginRight : "8px", background: "#009b57", border: "none", borderRadius: 100, fontWeight: 700, color : "#fff", boxShadow: "0 4px 12px rgba(0,154,87,.28)" }}>
                                            Search
                                        </button>
                                        <button type="submit" className="jsa-ghost" onClick={() => window.location.reload(true)} style={{ padding: "9px 22px", textAlign: "center", background: "#fff", border: "1.5px solid #dde5df", borderRadius: 100, fontWeight: 700, color: "#2c3d44" }}>
                                            Clear
                                        </button>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                    <Row>
                        <Col lg={1}></Col>
                        <Col lg={10}>
                            <Card className="mt-2" style={{ border: "1.5px solid #e8ede9", borderRadius: 18, boxShadow: "0 8px 26px rgba(20,50,38,.05)" }}>
                                <CardBody>
                                    <BootstrapTable
                                        keyField="headerId"
                                        data={ mainGrid.filter(x=>x.status !== "Process").sort((a, b) => a.id < b.id ? 1 : -1)  }
                                        columns={ columns }
                                        bordered={ false }
                                        rowEvents={ rowEvents }
                                        // className="no checkbox"
                                        // rowClasses="rowMargin no-checkbox"
                                        noDataIndication={ () => <div>No record found.</div> }
                                        cellEdit = { cellEditFactory({
                                            mode: 'dbclick',
                                            blurToSave: true,
                                            afterSaveCell: (oldValue, newValue, row, column) => {
                                                GridDataModified(oldValue, newValue, row.id, column.dataField , row)
                                                }
                                            })
                                        }
                                        selectRow = { selectRow }
                                        //striped
                                        hover
                                        condensed
                                    />
                                    <Row>
                                    </Row>
                                </CardBody>

                                

                                {/* urls3docs.length === 0 ? null : <FileViewer
                                    fileType={"pdf"}
                                    filePath={urls3docs}
                                    //errorComponent={CustomErrorComponent}
                                    //onError={this.onError}
                                /> */}
                                
                                {/* <iframe src={urls3docs} style={{ width: '100%', height: '500px', border: 'none' }} title="PDF Document"></iframe> */}
                                {/* <img src={urls3docs} style={{ width: '100%', height: '500px', border: 'none' }} alt="Image Document" />  */}
                            </Card>
                        </Col>
                        <Col lg={1}></Col>
                    </Row>
                </CardBody>:<CardBody>
                    {showViewer && (
                    <div className="viewer-overlay mt-5" onClick={() => setShowViewer(false)}>
                        <div
                        className="viewer-modal"
                        onClick={(e) => e.stopPropagation()}
                        >
                        <button
                            className="close-btn"
                            onClick={() => setShowViewer(false)}
                        >
                            ✕
                        </button>

                        <FileViewer
                            fileType={/* "pdf" */contentType}
                            filePath={urls3docs}
                            style={{ width: '10%', height: '100%', border: 'none' }}
                            //errorComponent={CustomErrorComponent}
                            //onError={this.onError}
                        />
                        </div>
                    </div>
                    )}
                </CardBody>}
            </Card>
            </div>
        </React.Fragment>
    );
};

export default ListOfCandidate;